if (!customElements.get('product-chart')) {
  class ProductChart extends HTMLElement {
    constructor() {
      super();
      this.sku = this.getAttribute('data-sku');
      this.currentPage = 1;
      this.itemsPerPage = 10;
      this.resultData = []; // To store fetched data
    }

    static get observedAttributes() {
      return ['data-sku']; // Observe changes to data-sku
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-sku') {
        this.sku = newValue; // Update the SKU
        setTimeout(()=>{
        this.fetchData(); // Re-fetch data when SKU changes
          },500);
      }
    }

    async fetchData() {
      let curSku = document.querySelector('product-chart').dataset.sku;
      const data = {
        sku: curSku,
      };

      try {
        const response = await fetch('https://dev.shopifyexperthelp.com/alpinesport/api/chart', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log(result)
        if (result.data) {
          this.resultData = result.data; // Store fetched data
          this.renderTable();
          this.renderPagination();
          this.updateItemCount(); // Update item count display
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }

    renderTable(page = 1) {
      let thisElement = this;
      let start = (page - 1) * this.itemsPerPage;
      let end = start + this.itemsPerPage;
      let paginatedData = this.resultData.slice(start, end);

      let tableRow = '';
      paginatedData.forEach((item) => {
        let category = 'ATV/UTV';
        let make = item.maker_name;
        let year = thisElement.formatYearRanges(item.build_year);
        let modal = item.model_name;
        //console.log(year)

        tableRow += `
          <tr role="row">
            <td role="gridcell">${category}</td>
            <td role="gridcell">${make}</td>
            <td role="gridcell" data-year="${item.build_year}"><p>${year}</p></td>
            <td role="gridcell">${modal}</td>
            <td role="gridcell"><span class="chart_note_popup_open hidden">See note</span></td>
          </tr>`;
      });

      if (tableRow) {
        this.classList.remove('hidden');
        this.querySelector('tbody').innerHTML = tableRow;
      }
    }

    formatYearRanges(years) {
      // Check if input is a string and convert to an array
      if (typeof years === 'string') {
          years = years.split(',').map(year => year.trim());
      }
      // Convert to numbers and sort
      const sortedYears = years.map(Number).sort((a, b) => a - b);
      const groupedYears = [];
      let currentGroup = [];
  
      // Iterate through sorted years
      for (let year of sortedYears) {
          // If current group is empty or the year is consecutive to the last year in the group
          if (currentGroup.length === 0 || year === currentGroup[currentGroup.length - 1] + 1) {
              currentGroup.push(year);
          } else {
              // Push the previous group to the result and start a new group
              groupedYears.push(currentGroup);
              currentGroup = [year];
          }
      }
      // Add the last group to the result if it exists
      if (currentGroup.length > 0) {
          groupedYears.push(currentGroup);
      }
  
      // Format the output
      const result = groupedYears.map(group => {
          if (group.length === 1) {
              return group[0].toString(); // Return single year as string
          }
          return `${group[0]}-${group[group.length - 1]}`; // Return the range
      });
  
      return result.join(', '); // Join with a comma and space
    }


    renderPagination() {
      let totalPages = Math.ceil(this.resultData.length / this.itemsPerPage);
      let paginationHtml = '';
      paginationHtml += `<button class="pagination-button first" ${this.currentPage === 1 ? 'disabled' : ''} data-page="1"><svg width="31.6px" height="31.6px" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="41.1875" cy="40.7969" r="39.3047" stroke="#D1D1D1" stroke-width="2"></circle><rect x="30.2129" y="30.6406" width="2.73828" height="20.3047" fill="#97908C"></rect><path d="M32.9512 40.8008L47.3594 32.4822L47.3594 49.1194L32.9512 40.8008Z" fill="#97908C"></path></svg></button>`;
      paginationHtml += `<button class="pagination-button prev" ${this.currentPage === 1 ? 'disabled' : ''} data-page="${this.currentPage - 1}"><svg class="left_side_svg" width="31.6px" height="31.6px" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="41.0547" cy="40.7969" r="39.3047" stroke="#D1D1D1" stroke-width="2"></circle><path d="M31.4492 40.793L45.8574 32.4744L45.8574 49.1115L31.4492 40.793Z" fill="#97908C"></path></svg></button>`;
      let visiblePages = 5;
      let startPage = Math.max(1, this.currentPage - 2);
      let endPage = Math.min(totalPages, this.currentPage + 2);
      if (startPage > 1) {
        paginationHtml += `<button class="pagination-button" data-page="1">1</button>`;
        if (startPage > 2) {
          paginationHtml += `<span class="ellipsis">...</span>`;
        }
      }
      for (let i = startPage; i <= endPage; i++) {
        let activeClass = i === this.currentPage ? 'active' : '';
        paginationHtml += `<button class="pagination-button ${activeClass}" data-page="${i}">${i}</button>`;
      }
      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          paginationHtml += `<span class="ellipsis">...</span>`;
        }
        paginationHtml += `<button class="pagination-button" data-page="${totalPages}">${totalPages}</button>`;
      }
      paginationHtml += `<button class="pagination-button next" ${this.currentPage === totalPages ? 'disabled' : ''} data-page="${this.currentPage + 1}"><svg width="31.6px" height="31.6px" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="39.3047" cy="39.3047" r="39.3047" transform="matrix(-1 0 0 1 80.4492 1.49219)" stroke="#D1D1D1" stroke-width="2"></circle><path d="M50.75 40.793L36.3418 32.4744L36.3418 49.1115L50.75 40.793Z" fill="#97908C"></path></svg></button>`;
      paginationHtml += `<button class="pagination-button last" ${this.currentPage === totalPages ? 'disabled' : ''} data-page="${totalPages}"><svg width="31.6px" height="31.6px" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="39.3047" cy="39.3047" r="39.3047" transform="matrix(-1 0 0 1 80.5254 1.5)" stroke="#D1D1D1" stroke-width="2"></circle><rect width="2.73828" height="20.3047" transform="matrix(-1 0 0 1 52.1953 30.6484)" fill="#97908C"></rect><path d="M49.457 40.8086L35.0488 32.49L35.0488 49.1272L49.457 40.8086Z" fill="#97908C"></path></svg></button>`;
      this.querySelector('#table-pagination').innerHTML = paginationHtml;
      this.querySelectorAll('.pagination-button').forEach((button) => {
        button.addEventListener('click', () => {
          let newPage = parseInt(button.getAttribute('data-page'));
          if (newPage && newPage !== this.currentPage) {
            this.currentPage = newPage;
            this.renderTable(this.currentPage);
            this.renderPagination();
            this.updateItemCount();
          }
        });
      });
    }

    updateItemCount() {
      const totalItems = this.resultData.length;
      const startItem = (this.currentPage - 1) * this.itemsPerPage + 1;
      const endItem = Math.min(startItem + this.itemsPerPage - 1, totalItems);

      // Display count
      const countElement = this.querySelector('.chart-product-count');
      if (countElement) {
        countElement.textContent = `${startItem} - ${endItem} of ${totalItems} items`;
      }
    }
  }

  customElements.define('product-chart', ProductChart);
}